import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { useAuth } from "../../../context/AuthContext";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";
import { Box, Paper, TextField, Button, Typography } from "@mui/material";

const InventoryAdjustPage: React.FC = () => {
  useProtectedRoute();
  const { token } = useAuth();
  const navigate = useNavigate();

  const [sku, setSku] = useState("");
  const [qty, setQty] = useState(0);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const valid = useMemo(() => sku.trim().length > 0 && Number(qty) !== 0, [sku, qty]);

  const handleAdjust = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!valid) { setError("Enter a SKU and a non-zero quantity."); return; }
    setLoading(true);
    try {
      await api.post("/inventory/adjust", { sku: sku.trim(), qty: Number(qty), reason: reason?.trim?.() }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert("Inventory adjusted.");
      navigate("/inventory");
    } catch (err: any) {
      const msg = err?.response?.data?.message || "Adjustment failed.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 720, mx: "auto", p: 2 }}>
      <Typography variant="h5" fontWeight={900} gutterBottom>Manual Inventory Adjustment</Typography>
      <Paper sx={{ p: 3 }}>
        {error && (
          <Typography color="error" sx={{ mb: 1 }}>{error}</Typography>
        )}
        <Box component="form" onSubmit={handleAdjust} sx={{ display: "grid", gap: 2 }}>
          <TextField label="Item SKU" value={sku} onChange={(e) => setSku(e.target.value)} required placeholder="Enter SKU or scan barcode" helperText={!sku.trim() ? 'SKU is required' : ' '} error={!sku.trim()} />
          <TextField label="Quantity (use negative for removal)" type="number" value={qty} onChange={(e) => setQty(Number(e.target.value))} required placeholder="e.g. 5 or -3" helperText={Number(qty)===0 ? 'Quantity must be non-zero' : ' '} error={Number(qty)===0} />
          <TextField label="Reason" value={reason} onChange={(e) => setReason(e.target.value)} placeholder="E.g. stocktake correction, loss, found, etc." />
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <Button type="submit" variant="contained" disabled={loading || !valid}>{loading ? "Processing..." : "Adjust"}</Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default InventoryAdjustPage;
